import { schema, t } from '@colyseus/schema'

/**
 * One row of the final standings, written once when the race ends (`finished`). Unfinished
 * players are ranked after the finishers by progress (ARCHITECTURE §5.2).
 */
export const ResultSchema = schema(
  {
    /** Key of the runner in `RaceState.players`. */
    sessionId: t.string().default(''),
    index: t.number().default(0),
    displayName: t.string().default(''),
    charId: t.number().default(0),
    /** Final position 1..4. */
    placement: t.number().default(0),
    finished: t.boolean().default(false),
    /** Race time from GO in ms; -1 when unfinished. */
    finishMs: t.number().default(-1),
    /** Furthest x reached. */
    progress: t.number().default(0),
    coins: t.number().default(0),
    /** XP this race earned (D-038), on every seat including bots; 0 for a leaver. */
    xp: t.number().default(0),
    /** Coins this race earned (placement + shards); 0 for a leaver. */
    coinsEarned: t.number().default(0),
  },
  'ResultSchema',
)
export type ResultSchema = InstanceType<typeof ResultSchema>
